import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SnippetService} from '../snippet.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-snippet-video',
  templateUrl: './snippet-video.component.html',
  styleUrls: ['./snippet-video.component.scss']
})
export class SnippetVideoComponent implements OnInit {
    @Input() snippet;
    @Output() action: EventEmitter<any> =  new EventEmitter<any>();

    editMode = false;
    showConfirmation = false;
    snippetEditModal = false;

    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };

    constructor(
        private snippetService: SnippetService,
        private toastrService: ToastrService,
    ) { }

    ngOnInit() {
    }

    edit() {
        this.editMode = true;
    }

    cancel() {
        this.editMode = false;
    }

    save() {
        this.editMode = false;
    }

    deleteConfirm() {
        this.confirmationData.title = 'Please confirm you would like to remove this section';
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;

    }
    confirmAction(e) {
        if (e.action) {
            this.snippetService.deleteSnippet(this.snippet).subscribe(data => {
                this.action.emit(true);
            });
        }
        this.confirmationData.open = false;
    }
    editSnippet() {
        this.snippetEditModal = true;
    }
    editModalAction(e) {
        this.snippetEditModal = false;
        if (e.completed) {
            this.toastrService.success('Page contents updated');
        }
    }

}
